import {
  CurrencyPipe,
  DOCUMENT,
  isPlatformBrowser,
  NgFor,
  NgIf,
  NgOptimizedImage,
  SlicePipe,
  TitleCasePipe,
  UpperCasePipe
} from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
  BehaviorSubject
} from 'rxjs';
import {
  AgencyForSearchCombined,
  AgencyService,
  AgentService, ProfessionistForSearch, ProfessionistService, ZoneService
} from 'src/app/api';
import {
  AppComponent
} from 'src/app/app.component';
import {
  AuthenticationService
} from 'src/app/services/authentication.service';
import {
  ConsoleLoggerService
} from 'src/app/services/console-logger.service';
import Constants, {
  SearchQuery
} from 'src/app/utils/Constants';
import {
  CommonComponent
} from '../../common/common.component';
import { ReturnEvent, SearchBarMapComponent } from '../search-bar-map/search-bar-map.component';

import { CurrencyITFormatPipe } from 'src/app/pipes/currency-itformat.pipe';
import {
  environment
} from 'src/environments/environment';
import { TooltipTpDirective } from '../../../directives/tooltip-tp.directive';
import { BadgeComponent } from '../badge/badge.component';
import { LoadingComponent } from '../loading/loading.component';
import { PopupAtecoComponent } from '../popup-ateco/popup-ateco.component';
import { SuggestedResultComponent } from '../suggested-result/suggested-result.component';

@Component({
  selector: 'app-search-bar-input',
  templateUrl: './search-bar-input.component.html',
  styleUrls: ['./search-bar-input.component.scss'],
  providers: [CurrencyPipe],
  standalone: true,
  imports: [NgIf, NgFor, LoadingComponent, RouterLink, BadgeComponent, SearchBarMapComponent, TooltipTpDirective, UpperCasePipe, SlicePipe, TitleCasePipe, CurrencyPipe, CurrencyITFormatPipe, PopupAtecoComponent, SuggestedResultComponent, NgOptimizedImage]
})
export class SearchBarInputComponent extends CommonComponent implements OnInit {
  imgLogoErrorArray = [];

  @Input() isHome = false;
  @Input() isAgency = false;
  @Input() isAgent = false;
  @Input() isSaved = false;
  @Input() is404 = false;
  @Input() isWhiteLabel = false;
  @Output() saveSearch = new EventEmitter();
  @Output() showMoreFiltersEvt = new EventEmitter();
  @ViewChild('globalSearchBarInput') globalSearchBarInput: ElementRef;
  isMobile: boolean;
  saveSearchValue = false;

  // PARAMETRI PER EFFETTUARE LA RICERCA
  searchValue = ''; // VALORE DI RICERCA
  searchPlaceholder = ''; // VALORE DI PLACEHOLDER
  searchCategoria: string; // SELEZIONA LA TIPOLOGIA DI IMMOBILE O LA COMPANY
  searchCoords: any;
  searchRadius: any;
  searchZona = '';
  searchComune = '';
  searchProvincia = '';
  searchRegione = '';

  placeholder = '';

  // DROPDOWN TIPOLOGIA IMMOBILE O AGENZIA
  openCategory = false;
  parentType: any = null;
  childType: any = [];

  searchMethod = 1; // METODO DI RICERCA: 1,2,3,4
  searchTimer: any;

  // PRENDE LE DUE LISTE DI TIPOLOGIE
  listOfTypologies: any = Constants.LIST_OF_TYPOLOGY;
  listOfCompany: any = Constants.LIST_OF_COMPANY;

  suggestionResult = null; // GENERA GLI INDIRIZZI DA SUGGERIRE
  toggleSearch = false; // DECIDE SE SUGGERIRE INDIRIZZI O METODI DI RICERCA

  // GESTIONE MAPPA
  showMap = false; // DECIDE SE MOSTRARE LA MAPPA DI RICERCA
  openMapSubject: BehaviorSubject<number> = new BehaviorSubject<number>(1);

  // GRUPPI E ASSOCIAZIONI
  associations: any[] = Constants.LIST_OF_ASSOCIATIONS;
  // selectedAssociations: string[] = [];
  showAgencies = true;
  showAssociations = true;

  // Mobile fixed list
  openFixedList = false;


  // FILTRO ORDINA ATTIVITA
  activities = this.main.activities;
  activitiesLabel = 'Attività';

  // ZONE DEI COMUNI
  cityZones: any[] = [];
  cityZonesSelected: any[] = [];
  selectedCity: any;

  // GESTIONE FILTRAGGIO
  public idDropdownOpen = '';
  public listRange = 1;

  // MOSTRA / NASCONDE BARRA DEI FILTRI IN MOBILE
  showFilters = false;

  // PLACEHOLDER FILTRAGGI
  public optionsPrice = [20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200, 220, 240, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1500, 2000, 2500];
  public optionsMQ = [20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 350, 400, 550, 600, 700, 800, 900, 1000];
  public optionsLocali = [1, 2, 3, 4, 5, 6];
  public optionsFinanziamento = [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 2000, 3000];
  public optionsExp = [];
  suggestionFocus: number;

  // isAgentSearch = true;

  public popupAtecoIsOpen = false;
  public atecoType = '';
  public atecoObj: any;
  public atecoAgentFullName: string;
  public esponenteName: string;

  @Output() resetFilterEvent = new EventEmitter();

  constructor(
    private zones: ZoneService,
    private router: Router,
    private route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public agentService: AgentService,
    public agencyService: AgencyService,
    public professionistService: ProfessionistService,
    public main: AppComponent,
    private cp: CurrencyPipe,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private document: Document,
    private console: ConsoleLoggerService
  ) {
    super(authenticationService);
  }

  async ngOnInit(): Promise<void> {
    console.log('log from search bar');
    for (let i = 1; i <= 50; i++) {
      this.optionsExp.push(i);
    }
    if (this.isAgency) {
      this.main.searchType = 'agenzia';
    }
    if (this.isAgent) {
      this.main.searchType = 'agente';
    }

    if (!this.is404) {
      this.route.queryParams.subscribe(async (params: any) => {
        const obj = this.main.getParamsURL(this.router.url, params, this.main.searchType);
        this.searchRadius = obj.searchRadius;
        this.searchCoords = obj.searchCoords;
        this.searchCategoria = obj.searchCategoria;
        this.main.isAgentSearch = obj.searchType !== 'professionista';
        this.main.searchType = obj.searchType !== 'professionista' ? obj.searchType : 'agente';
        this.searchComune = obj.searchComune;
        this.searchPlaceholder = obj.searchPlaceholder;
        this.searchZona = obj.searchZona;
        this.searchProvincia = obj.searchProvincia;
        this.searchRegione = obj.searchRegione;
        this.searchValue = obj.searchValue;
        this.searchMethod = obj.searchMethod;
        if (!this.isHome && !this.is404) {
          this.main.searchMethodType = 'place';
        }
        this.getDropdownType(this.searchCategoria);
      });
    }

    if (isPlatformBrowser(this.platformId)) {
      window.innerWidth > 768 ? this.isMobile = false : this.isMobile = true;
    }

    this.placeholder = this.isWhiteLabel ? 'Inserisci Indirizzo, Città, Zona o Disegna sulla mappa' : 'Inserisci il nome dell\'agente immobiliare o dell\'agenzia';
  }


  // SELEZIONA IL METODO DI RICERCA
  selectOption(zone: any): void {
    // this.main.composeBreadcrumb(zone);
    this.cityZonesSelected = [];
    this.main.searchDropdown = false;
    this.toggleSearch = false;
    this.searchValue = `${zone.name} • (${zone.type})`;
    this.searchPlaceholder = this.searchValue;
    this.searchRegione = '';
    this.searchProvincia = '';
    this.searchZona = '';
    this.searchComune = '';
    this.searchCoords = '';
    this.searchRadius = '';
    this.searchMethod = 1;
    switch (zone.type) {
      case 'Regione':
        this.searchRegione = zone.name;
        break;
      case 'Provincia':
        this.searchProvincia = zone.name;
        break;
      case 'Comune':
        const cityZones = zone.children.filter(z => z.type === 'Zona');
        if (cityZones.length) {
          this.handleCityZones(zone, cityZones);
        } else {
          this.searchComune = zone.name;
        }
        break;
      case 'Zona':
        this.searchZona = zone.name;
        break;
      case 'Google':
        this.searchCoords = zone.geometry.coordinates;
        break;
    }
  }

  // GESTISCE ZONE DEI COMUNI
  handleCityZones(city: any, zones: any[]): void {
    this.cityZones = zones;
    this.main.searchDropdownCityZones = true;
    this.searchComune = city.name;
    this.selectedCity = city;
    if (window.innerWidth <= 991) {
      this.document.documentElement.style.overflow = 'hidden';
    }
  }

  clickOnCityZone(zoneName: string): void {
    const index = this.cityZonesSelected.indexOf(zoneName);
    if (index > -1) {
      this.cityZonesSelected.splice(index, 1);
    } else {
      this.cityZonesSelected.push(zoneName);
    }
    if (this.cityZonesSelected.length) {
      this.searchValue = 'Zone selezionate:' + ' ' + this.cityZonesSelected.join(', ');
      this.searchPlaceholder = 'Zone selezionate:' + ' ' + this.cityZonesSelected.join(', ');
    } else {
      this.searchValue = this.searchComune + ' • (Comune)';
      this.searchPlaceholder = this.searchComune + ' • (Comune)';
    }
  }

  checkSelectedZones(zoneName: string): boolean {
    const index = this.cityZonesSelected.indexOf(zoneName);
    return index > -1;
  }

  selectAllCityZones(e: Event): void {
    const target = e.target as HTMLInputElement;
    if (!target.checked) {
      this.main.searchDropdownCityZones = false;
    }
    target.checked = true;
    this.cityZonesSelected = [];
    this.searchValue = this.searchComune + ' • (Comune)';
    this.searchPlaceholder = this.searchComune + ' • (Comune)';
  }

  returnSortedArray(): any[] {
    return this.cityZones.sort((a, b) => {
      if (a.display_name < b.display_name) {
        return -1;
      }
      if (a.display_name > b.display_name) {
        return 1;
      }
      return 0;
    });
  }

  // CAMBIA LA TIPOLOGIA DI RICERCA
  async setSearchQueryTypeTo(type: string): Promise<void> {
    if (type !== this.main.searchType) {
      this.toggleSearch = false;
      this.main.resetSearchFilter();
      if (type === 'vendita' || type === 'affitto') {
        this.main.searchMethodType = 'place';
        this.suggestionResult = null;
      } else {
        this.suggestionResult = null;
      }
      this.main.searchType = type;
      if (this.main.searchMethodType === 'place') {
        this.placeholder = 'Inserisci Indirizzo, Città, Zona o Disegna sulla mappa';
      }
      this.selectAll();
    }
    // OPEN AGENT / CONSULENT DROPDOWN IN MOBILE
    if (this.isMobile && type === 'agente') {
      this.toggleMobileDropdown();
    }

    if (!this.isHome) {
      this.removeFilters();
      await this.applySearch();
    }
  }

  // CLICK TAB PROFESSIONISTI
  async handleClickOnProfessionistTab(): Promise<void> {
    // this.main.searchMethodType = 'name';
    this.main.searchType = 'agente';
    this.placeholder = 'Inserisci il nome dell\'agente immobiliare o dell\'agenzia';

    this.main.resetSearchFilter();
    this.searchCategoria = null;

    if (!this.isHome) {
      await this.applySearch();
    }
  }

  // RESET DELL'INPUT
  resetAndOpenInput(force?: boolean): void {
    if (this.isHome || force) {
      if (isPlatformBrowser(this.platformId)) {
        this.searchValue = '';
        (document.getElementById('globalSearchBarInput') as HTMLInputElement).value = this.searchValue;
        this.main.searchDropdown = true;
        this.cityZonesSelected = [];
        this.selectedCity = undefined;
      }
    }
  }

  // LISTENER SUL INPUT DI RICERCA
  onKeyUpInput(evt: KeyboardEvent, query: string): void {
    switch (evt.key) {
      case 'Enter': {
        // ricerca per nome
        if (this.main.searchMethodType === 'name') {
          if (query && query?.length >= 3) {
            this.handleRedirectOnDetailPages();
          }
        } else {
          if (query && query?.length >= 1) {
            if (this.main.searchDropdownCityZones === true) {
              this.applySearch();
              this.main.searchDropdownCityZones = false;
            } else {
              this.selectOption(this.suggestionResult[this.suggestionFocus]);
              if (!(this.suggestionResult[this.suggestionFocus]?.children?.length && this.suggestionResult[this.suggestionFocus]?.type === 'Comune')) {
                this.applySearch();
                this.main.searchDropdownCityZones = false;
              }
            }
          }
        }
        break;
      }
      case 'ArrowUp': {
        this.suggestionFocus > 1 ? this.suggestionFocus-- : this.suggestionFocus = 0;
        break;
      }
      case 'ArrowDown': {
        this.suggestionFocus < this.suggestionResult?.length - 1 ? this.suggestionFocus++ : this.suggestionFocus = this.suggestionResult?.length - 1;
        break;
      }
      case 'ArrowRight': {
        break;
      }
      case 'ArrowLeft': {
        break;
      }
      default: {
        this.suggestionFocus = 0;
        this.suggestionResult = null;
        clearTimeout(this.searchTimer);
        if (query.length > 0) {
          if (this.main.searchMethodType === 'place') {
            this.toggleSearch = true;
            const id = this.currentUser != null && this.currentUser.id != null ? this.currentUser.id : null;
            this.searchTimer = setTimeout(() => {
              this.zones.zoneSearch(query, id, 1).subscribe((success) => {
                this.suggestionResult = success;
              });
            }, 450);
          }
          if (this.main.searchMethodType === 'name' && query.length > 2) {
            this.toggleSearch = true;
            if (this.main.searchType === 'agente') {
              this.searchTimer = setTimeout(() => {
                if (this.isWhiteLabel) {
                  // ricerca agente bnl
                  this.agentService.agentSearchByName(query).subscribe((success) => {
                    this.suggestionResult = success;
                    this.suggestionResult = this.suggestionResult.filter((sr: any) => sr.agent);
                    if (environment.showProfessionist === false) {
                      this.suggestionResult = this.suggestionResult.filter((sr: any) => !sr.professionist);
                    }
                  });
                } else if (this.main.isAgentSearch) {
                  // ricerca combinata
                  this.agencyService.agencySearchByNameCombined(query).subscribe((success: AgencyForSearchCombined[]) => {
                    this.suggestionResult = success;
                  });
                } else {
                  // ricerca per nome professionisti
                  this.professionistService.professionistSearchByNameGetProfessionistsSearchByName(query).subscribe((success: ProfessionistForSearch[]) => {
                    this.suggestionResult = success;
                  });
                }
              }, 450);

            } else if (this.main.searchType === 'agenzia') {
              const filter = {
                where: {
                  and: [{ suspended: false }, { name: { regexp: '/' + query + '/i' } }, { profile_verified: { inq: ['whuis', 'fiaip', 'admin'] } }],
                },
                limit: 50,
              };
              this.agencyService.agencySearchByName(query).subscribe((success) => {
                this.suggestionResult = success;
              });
              this.imgLogoErrorArray = [];
            }
          }

        } else {
          this.toggleSearch = false;
        }
      }
    }
  }

  handleRedirectOnDetailPages(): void {
    if (this.suggestionResult[this.suggestionFocus].professionist) {
      this.router.navigate(['/consulente-credito-mutui-prestiti-assicurazioni/' + this.suggestionResult[this.suggestionFocus].professionist.slug]);
    }
    switch (this.suggestionResult[this.suggestionFocus].type) {
      case 'agent': {
        this.router.navigate(['/dettaglio-agente/' + this.suggestionResult[this.suggestionFocus].data.agent.slug]);
        break;
      }
      case 'agency': {
        this.router.navigate(['/dettaglio-agenzia/' + this.suggestionResult[this.suggestionFocus].data.slug]);
        break;
      }
      case 'ateco_company': {
        this.router.navigate(['/dettaglio-agenzia-ateco/' + this.suggestionResult[this.suggestionFocus].data.slug]);
        break;
      }
      case 'ateco_company_agent': {
        let el;
        this.suggestionResult[this.suggestionFocus].data.esponenti.forEach((esp: any) => {
          if (esp.name === this.suggestionResult[this.suggestionFocus].name) {
            el = esp.slug;
          }
        });
        this.router.navigate(['/dettaglio-agente-ateco/' + el]);
        break;
      }
    }
  }

  // QUANDO VIENE CHIUSA LA MAPPA DI SELEZIONE ZONA
  getEventAndCloseMap(e: ReturnEvent): void {
    this.resetAndOpenInput();
    this.searchComune = undefined;
    this.showMap = false;
    if (e && e.placeholder) {
      this.searchValue = e.placeholder;
      this.searchPlaceholder = e.placeholder;
    }
    if (e) {
      if (e.results.length > 0) {
        // this.main.composeBreadcrumb(e.results[0]);
        switch (e.metodo) {
          case 2:
            this.searchRadius = parseInt(e.results[0].properties.radius, 10);
            this.searchCoords = e.results[0].geometry.coordinates;
            break;
          case 3:
            const z = [];
            const c = [];
            const p = [];
            e.results.forEach((element) => {
              if (element.properties.type.toLowerCase() === 'provincia') {
                p.push(element.properties.name);
              } else if (element.properties.type.toLowerCase() === 'comune') {
                c.push(element.properties.name);
              } else if (element.properties.type.toLowerCase() === 'zona') {
                z.push(element.properties.name);
              }
            });
            this.searchProvincia = p.join(',');
            this.searchComune = c.join(',');
            this.searchZona = z.join(',');
            break;
          case 4:
            this.searchCoords = e.results[0].geometry.coordinates;
            break;
        }
        this.main.searchDropdown = false;
      }
    } else {
      this.searchMethod = 1;
    }
  }

  // SELEZIONA LA TIPOLOGIA DI RICERCA: VICINO A TE, SELEZIONA ZONA, DISEGNA AREA
  selezionaTipologiaRicerca(id): void {
    this.searchRegione = '';
    this.searchProvincia = '';
    this.searchZona = '';
    this.searchComune = '';
    this.searchCoords = '';
    this.searchRadius = '';
    this.searchMethod = id;
    this.openMapSubject.next(id);
    this.showMap = true;
    this.main.searchDropdownCityZones = false;
  }

  // CLICK SUL PULSANTE DI RICERCA
  async applySearch(): Promise<void> {
    console.log('apply search 1')
    if (this.isHome) {
      this.main.resetSearchFilter();
      this.changeActivitiesStatus('', null);
    }
    if (this.cityZonesSelected.length > 0) {
      this.searchZona = this.cityZonesSelected.toString();
      this.searchComune = '';
    }
    const queryParams: SearchQuery = this.generateQueryParams();
    //await this.router.navigateByUrl('/', { skipLocationChange: true });

    const obj = {};

    let goto = this.main.searchType;
    if (this.main.searchType === 'agente' && !this.main.isAgentSearch) {
      goto = 'professionista';
    }

    if (!this.isWhiteLabel) {
      console.log('apply search 2')
      const searchUrl = this.main.generateSearchURL(this.searchRegione, this.searchProvincia, this.searchComune, this.searchZona, this.parentType, this.searchCategoria, this.main.orderList, obj);
      await this.router.navigate([goto + searchUrl], {
        queryParams,
      });
    } else {
      const agencyName = window.location.pathname.split('/')[1];
      await this.router.navigate([agencyName + '/' + goto + this.main.generateSearchURL(this.searchRegione, this.searchProvincia, this.searchComune, this.parentType, this.searchZona, this.searchCategoria, this.main.orderList, obj)], {
        queryParams,
      });
    }
    // this.searchValue = '';
  }

  // DECIDE SE DISABILITARE IL PULSANTE DI RICERCA
  searchDisabled(): boolean {
    return !(this.searchValue && this.searchValue !== '');
  }

  // GENERA L'OGGETTO QUERY
  generateQueryParams(): {} {
    const obj: {} = {};
    // add method and placeholder in the url if i'm using map for search
    if (this.searchMethod !== 1) {
      if (this.searchPlaceholder) {
        Object.assign(obj, { placeholder: this.searchPlaceholder });
      }
      if (this.searchMethod) {
        Object.assign(obj, { metodo: this.searchMethod });
      }
    }

    if (this.searchCoords) {
      Object.assign(obj, { coords: this.searchCoords });
    }
    if (this.searchRadius) {
      Object.assign(obj, { raggio: this.searchRadius });
    }

    // BUY - RENT
    const filterBuyAndRent = {
      minPrice: 'con_prezzo_min',
      maxPrice: 'con_prezzo_max',
      minMQ: 'con_superficie_min',
      maxMQ: 'con_superficie_max',
      minLocali: 'con_locali_min',
      maxLocali: 'con_locali_max',
      minFinanziamento: 'finanziamentoMin',
      maxFinanziamento: 'finanziamentoMax',
      bathrooms: 'con_bagni',
      conditions: 'condizioni',
      context: 'contesto',
      extra: 'extra',
      floors: 'piano',
      garage: 'garage',
      garden: 'giardino',
      heating: 'riscaldamento',
      is_auction: 'asta_immobiliare',
      kitchen: 'con_cucina',
      exclusive: 'in_esclusiva'
    };

    // Iterate over the filterBuyAndRent and assign values if they exist
    Object.keys(filterBuyAndRent).forEach(filterKey => {
      const value = this.main.filtersList[filterKey];
      if (value) {
        const queryKey = filterBuyAndRent[filterKey];
        Object.assign(obj, { [queryKey]: value });
      }
    });

    // Check if there's an order and add it
    if (this.main.orderList.order !== '') {
      Object.assign(obj, { ordine: this.main.orderList.order });
    }

    // AGENT - AGENCY - PROFESSIONIST
    const getKey = (baseKey: string): string => {
      return this.main.searchType === 'agente' && this.main.isAgentSearch
        ? `agenti_${baseKey}`
        : `professionisti_${baseKey}`;
    };

    const filterAgentAndProfessionist = [
      { key: 'con_esperienza_minima', value: this.main.filtersList.minExp },
      { key: 'con_esperienza_massima', value: this.main.filtersList.maxExp },
      { key: 'che_parlano', value: this.main.filtersList.languages },
      { key: 'specializzati_in', value: this.main.filtersList.specializations }
    ];

    filterAgentAndProfessionist.forEach(filter => {
      if (filter.value) {
        const dynamicKey = getKey(filter.key);
        Object.assign(obj, { [dynamicKey]: filter.value });
      }
    });

    if (this.main.filtersList.associations) {
      const key = this.main.searchType === 'agenzia'
        ? 'associate'
        : 'associati';

      Object.assign(obj, { [key]: this.main.filtersList.associations });
    }
    // AGENT
    if (this.main.filtersList.mandates) {
      Object.assign(obj, { agenti_con_incarico: this.main.filtersList.mandates });
    }
    if (this.main.filtersList.opportunity) {
      Object.assign(obj, { agenti_in_cerca_di_opportunita: this.main.filtersList.opportunity });
    }
    if (this.main.filtersList.collab) {
      Object.assign(obj, { collaborazione_tra_agenti: this.main.filtersList.collab });
    }
    return obj;
  }

  // *******************************************************************
  // *******************************************************************
  // *******************************************************************
  // GESTIONE DROPDOWN TIPOLOGIA DI RICERCA: NOME O LUOGO
  // *******************************************************************
  // *******************************************************************
  // *******************************************************************

  // CLICK DELLA TIPOLOGIA DI RICERCA
  clickMethodType(index): void {
    if (this.main.searchMethodType !== index) {
      this.resetAndOpenInput();
      this.resetSuggestionResults();
      this.main.searchMethodType = index;
      if (index === 'place') {
        this.placeholder = 'Inserisci Indirizzo, Città, Zona o Disegna sulla mappa';
      } else {
        if (this.main.searchType === 'agenzia') {
          this.placeholder = 'Inserisci il nome dell\'agenzia';
          this.searchValue = '';
        } else if (this.main.searchType === 'agente') {
          this.placeholder = this.isWhiteLabel ? 'Inserisci il nome dell\'agente immobiliare' : 'Inserisci il nome dell\'agente immobiliare o del consulente del credito';
          this.searchValue = '';
        }
      }
    }
  }

  // *******************************************************************
  // *******************************************************************
  // *******************************************************************
  // GESTIONE DROPDOWN CATEGORIA DI RICERCA
  // *******************************************************************
  // *******************************************************************
  // *******************************************************************

  // SELEZIONA TUTTO IL DROPDOWN
  selectAll(): void {
    this.searchCategoria = null;
    this.parentType = null;
    this.childType = [];
    this.openCategory = false;
  }

  // CLICK SU MACRO CATEGORIA
  clickParentType(type, triggerOpen): void {
    if (this.main.searchType === 'agenzia' || this.main.searchType === 'agente') {
      this.parentType = type;
      this.searchCategoria = this.parentType.id;
    } else {
      this.childType = [];
      this.searchCategoria = null;
      this.parentType = type;

      if (this.parentType.value.length > 1) {
        const array = [];
        this.parentType.value.forEach((subtype) => {
          array.push(subtype.value);
        });
        this.searchCategoria = array.join(',');
      } else {
        this.searchCategoria = this.parentType.value[0].value;
      }

      if (triggerOpen) {
        this.openCategory = this.parentType.id === this.openCategory ? '' : this.parentType.id;
      }
    }
  }

  // E SELEZIONATA LA MACRO CATEGORIA
  selectedParentType(type): string | boolean {
    if (this.parentType && this.parentType.id) {
      return type.id === this.parentType.id;
    } else {
      return false;
    }
  }

  // CLICK SU SOTTO CATEGORIA
  clickChildType(subType, macroType): void {
    const array = [];
    this.searchCategoria = '';

    const index = this.childType.findIndex((item) => item.value === subType.value);

    if (index !== -1) {
      this.childType.splice(index, 1);
    } else {
      this.childType.push(subType);
    }
    this.childType.forEach((element) => {
      array.push(element.value);
    });
    this.searchCategoria = array.join(',');
    if (this.childType.length === macroType.value.length) {
      this.clickParentType(macroType, false);
    }
  }

  // E SELEZIONATA LA SOTTO CATEGORIA
  selectedChildType(subType): boolean {
    if (this.childType.length === 0) {
      return false;
    } else { return this.childType.filter((item) => item.value === subType.value).length > 0; }
  }

  removeParentType(): void {
    this.parentType = null;
    this.searchCategoria = undefined;
  }

  // MOSTRA LA LABEL DELLA TIPOLOGIA DI RICERCA
  showLabelType(): string {
    if (this.main.searchType === 'agenzia') {
      if (this.parentType) {
        if (this.main.filtersList.associations && this.main.filtersList.associations.length) {
          return this.parentType.text + ', ' + this.showAssociationsLabel();
        }
        return this.parentType.text;
      } else if (this.main.filtersList.associations && this.main.filtersList.associations.length) {
        return this.showAssociationsLabel();
      } else {
        return 'Tutte';
      }
    } else if (this.main.searchType === 'agente') {
      return this.main.isAgentSearch ? 'Agenti immobiliari' : 'Consulenti del credito e assicurativo';
    } else {
      if (this.parentType) {
        if (this.parentType.value.length === 1) {
          return this.parentType.text;
        } else if (this.childType.length === 0 && this.parentType.value.length > 1) {
          return (this.parentType.text + ' • ' + this.parentType.value.length + ' tipologie');
        } else if (this.childType.length > 0 && this.parentType.value.length > 1) {
          return (this.parentType.text + ' • ' + this.childType.length + ' tipologie');
        }
      } else if (this.main.searchType === 'professionista') {
        return 'Consulenti del credito e assicurativo';
      } else {
        return 'Tutte le tipologie';
      }
    }
  }

  showActivitiesLabel(value): string {
    if (value) {
      if (value.includes('property')) {
        return 'Property finder';
      }
      if (value.includes('mutui')) {
        return 'Mutui e Prestiti';
      }
      return value;
    }
    return this.activitiesLabel;
  }

  // PRENDE LE CATEGORIE DALL'URL E LE CONVERTE PER ATTIVARE IL DROPDOWN
  getDropdownType(stringCategories): void {
    if (stringCategories && stringCategories !== '') {
      if (this.main.searchType === 'agenzia' || this.main.searchType === 'agente') {
        this.listOfCompany.forEach((company) => {
          if (stringCategories.toString().toLowerCase() === company.id.toString().toLowerCase()) {
            this.parentType = company;
            this.searchCategoria = this.parentType.id;
          }
        });
      } else {
        const categories = stringCategories.split(',');
        this.listOfTypologies.forEach((macroType) => {
          macroType.value.forEach((subType) => {
            if (categories.indexOf(subType.value) !== -1) {
              this.childType.push(subType);
              this.parentType = macroType;
              this.openCategory = this.parentType.id;
            }
          });
        });
        if (this.parentType && this.childType.length === this.parentType.value.length) {
          this.childType = [];
          this.openCategory = false;
        }
      }
    }
  }

  // *******************************************************************
  // *******************************************************************
  // *******************************************************************
  // GESTIONE DELLE RICERCHE RECENTI NEL BOX DEI SUGGERIMENTI DI RICERCA
  // *******************************************************************
  // *******************************************************************
  // *******************************************************************

  typeSearchIcon(value): string {
    if (value.metodo === 2) {
      return 'icon-street-view';
    } else if (value.metodo === 3) {
      return 'icon-map-pin';
    } else if (value.metodo === 4) {
      return 'icon-draw-polygon';
    } else {
      return 'icon-map-marker-alt';
    }
  }

  // ********************************************************************
  // ********************************************************************
  // ********************************************************************
  // GESTIONE DEL FILTRAGGIO
  // ********************************************************************
  // ********************************************************************
  // ********************************************************************

  // CLICK SUL VALORE DA FILTRARE
  setFilter(id, value, section, inputId): void {
    if (isPlatformBrowser(this.platformId)) {
      if (inputId) {
        inputId.focus();
      }
      this.main.filtersList[id] = value;
      (document.getElementById(id) as HTMLInputElement).value = value;
      if (!section) {
        this.idDropdownOpen = '';
      } else {
        this.listRange = section;
      }
    }
    // Aggiorna in automatico la ricerca se cambiano i filtri
    if (id === 'maxPrice' || id === 'maxMQ' || id === 'maxLocali' || id === 'maxFinanziamento' || id === 'maxExp') {
      this.applySearch();
    }
  }

  handleExlusivityInput(): any {
    if (this.main?.filtersList) {
      this.main.filtersList.exclusive = !this.main.filtersList?.exclusive;
    }
    this.applySearch();
  }

  // CAMBIA VALORE ALL'INTERNO DEL DROPDOWN
  changeValue(value, id): void {
    this.main.filtersList[id] = value;
  }

  // TOGGLE PER APRIRE IL DROPDOWN
  openDrodown(id, inputId: HTMLInputElement | undefined): void {
    this.idDropdownOpen = this.idDropdownOpen === id ? '' : id;
    if (inputId !== undefined) {
      setTimeout(() => {
        inputId.focus();
      }, 100);
    }
  }

  // QUANDO VIENE FATTO IL FOCUS SUL PRIMO INPUT
  onFocusInput(id): void {
    this.listRange = id;
  }

  // SE L'UTENTE CLICCA FUORI DAL DROPDOWN VIENE CHIUSO
  @HostListener('window:click', ['$event.target']) onClick(target): void {
    let clickedInside = false;
    if (isPlatformBrowser(this.platformId)) {
      Array.prototype.forEach.call(document.getElementsByClassName('filtersAnnuncio'), (element) => {
        if (element.contains(target)) {
          clickedInside = true;
        }
      });
    }
    if (!clickedInside) {
      this.idDropdownOpen = '';
    }
  }

  // ********************************************************************
  // MOSTRA IL TESTO DEI FILTRI
  // ********************************************************************

  // MOSTRA IL TESTO - PREZZO
  showPriceLabel(): string {
    const max = this.main.filtersList.maxPrice ? this.cp.transform(this.main.filtersList.maxPrice, 'EUR', '€', '1.0-2').replace(/,/g, '.').toString() : '';
    const min = this.main.filtersList.minPrice ? this.cp.transform(this.main.filtersList.minPrice, 'EUR', '€', '1.0-2').replace(/,/g, '.').toString() : '';
    if (!min && !max) {
      return this.main?.searchType === 'affitto' ? 'Prezzo Affitto' : 'Prezzo';
    } else if (!min && max !== '') {
      return this.main?.searchType === 'affitto' ? 'fino a ' + max + ' al mese' : 'fino a ' + max;
    } else if (!max && min !== '') {
      return this.main?.searchType === 'affitto' ? 'a partire da ' + min + ' al mese' : 'a partire da ' + min;
    } else if (max === min) {
      return min;
    } else {
      return 'da ' + min + ' a ' + max;
    }
  }

  // MOSTRA IL TESTO - SUPERFICIE
  showMQLabel(min, max): string {
    if (!min && !max) {
      return 'Superficie';
    } else if (!min && max !== '') {
      return 'fino a ' + max + 'mq';
    } else if (!max && min !== '') {
      return 'da ' + min + 'mq';
    } else if (max === min) {
      return min + 'mq';
    } else {
      return 'da ' + min + 'mq a ' + max + 'mq';
    }
  }

  // MOSTRA IL TESTO - LOCALI
  showLocaliLabel(min, max): string {
    if (!min && !max) {
      return 'Locali';
    } else if (!min && max !== '') {
      return '<b>Locali</b>: fino a ' + max;
    } else if (!max && min !== '') {
      return '<b>Locali</b>: da ' + min;
    } else if (max === min) {
      return '<b>Locali</b>: ' + min;
    } else {
      return '<b>Locali</b>: da ' + min + ' a ' + max;
    }
  }

  // MOSTRA IL TESTO - ANNI EXP
  showExpLabel(min, max): string {
    if (!min && !max) {
      return 'Anni di esperienza';
    } else if (!min && max !== '') {
      if (min > 1) {
        return 'fino a ' + max + ' anni';
      } else {
        return 'fino a ' + max + ' anno';
      }
    } else if (!max && min !== '') {
      if (min > 1) {
        return 'da ' + min + ' anni';
      } else {
        return 'da ' + min + ' anno';
      }
    } else if (max === min) {
      if (min > 1) {
        return min + ' anni';
      } else {
        return min + ' anno';
      }
    } else {
      return 'da ' + min + ' a ' + max + ' anni';
    }
  }

  // MOSTRA IL TESTO - MUTUO
  showFinanziamentoLabel(min, max): string {
    max = max ? this.cp.transform(max, 'EUR', '€', '1.0-2').replace(/,/g, '.').toString() : '';
    min = min ? this.cp.transform(min, 'EUR', '€', '1.0-2').replace(/,/g, '.').toString() : '';
    if (!min && !max) {
      return 'Rata mensile finanziamento';
    } else if (!min && max !== '') {
      return '<b>Finanziamento</b>: fino a ' + max;
    } else if (!max && min !== '') {
      return '<b>Finanziamento</b>: da ' + min;
    } else if (max === min) {
      return '<b>Finanziamento</b>: ' + min;
    } else {
      return '<b>Finanziamento</b>: da ' + min + ' a ' + max;
    }
  }

  // MOSTRA LABEL FILTRI
  showAssociationsLabel(): string {
    if (this.main.filtersList.associations == null || this.main.filtersList.associations.length === 0) {
      return 'Tutte le associazioni';
    } else if (this.main.filtersList.associations.length === 1) {
      return this.main.filtersList.associations[0].toUpperCase();
    } else {
      return `${this.main.filtersList.associations.length} Associazioni`;
    }
  }

  showLanguagesLabel(): string {
    if (this.main.filtersList.languages == null || this.main.filtersList.languages.length === 0) {
      return 'Lingue';
    } else if (this.main.filtersList.languages.length === 1) {
      return '1 Lingua selezionata';
    } else {
      return `${this.main.filtersList.languages.length} Lingue selezionate`;
    }
  }

  showSpecializationsLabel(): string {
    if (this.main.filtersList.specializations == null || this.main.filtersList.specializations.length === 0) {
      return 'Specializzazioni';
    } else if (this.main.filtersList.specializations.length === 1) {
      return '1 Specializzazione selezionata';
    } else {
      return `${this.main.filtersList.specializations.length} Specializzazioni selezionate`;
    }
  }

  showMandatesLabel(): string {
    if (this.main.filtersList.mandates == null || this.main.filtersList.mandates.length === 0) {
      return 'Incarico';
    } else if (this.main.filtersList.mandates.length === 1) {
      return '1 Mandato selezionato';
    } else {
      return `${this.main.filtersList.mandates.length} Mandati selezionati`;
    }
  }

  // GESTISCE CHECKBOX SELEZIONATI PER LE ASSOCIAZIONI DI AGENTI E AGENZIE
  checkChekbox(id: string, array: string[]): boolean {
    return array != null && array.indexOf(id) >= 0;
  }

  // GESTISCE CHECKBOX SELEZIONATI PER ASSOCIAZIONI, SPECIALIZZAZIONI, LINGUE
  changeAssociationsStatus(id: string, e: Event): void {
    if (this.main.filtersList.associations == null) {
      this.main.filtersList.associations = [];
    }

    if (this.main.filtersList.associations.indexOf(id) < 0) {
      this.main.filtersList.associations.push(id);
    } else {
      this.main.filtersList.associations.splice(this.main.filtersList.associations.indexOf(id), 1);
    }
  }

  changeSpecializationsStatus(id: string, e: Event): void {
    if (this.main.filtersList.specializations === null) {
      this.main.filtersList.specializations = [];
    }
    if (this.main.filtersList.specializations.indexOf(id) < 0) {
      this.main.filtersList.specializations.push(id);
    } else {
      this.main.filtersList.specializations.splice(this.main.filtersList.specializations.indexOf(id), 1);
    }
    this.applySearch();
  }

  changeLanguagesStatus(id: string, e: Event): void {
    if (this.main.filtersList.languages === null) {
      this.main.filtersList.languages = [];
    }

    if (this.main.filtersList.languages.indexOf(id) < 0) {
      this.main.filtersList.languages.push(id);
    } else {
      this.main.filtersList.languages.splice(this.main.filtersList.languages.indexOf(id), 1);
    }
    this.applySearch();
  }

  changeMandatesStatus(id: string, e: Event): void {
    if (this.main.filtersList.mandates === null) {
      this.main.filtersList.mandates = [];
    }

    if (this.main.filtersList.mandates.indexOf(id) < 0) {
      this.main.filtersList.mandates.push(id);
    } else {
      this.main.filtersList.mandates.splice(this.main.filtersList.mandates.indexOf(id), 1);
    }
    this.applySearch();
  }

  removeAssociations(): void {
    this.main.filtersList.associations = null;
  }

  handleOpportunityFilters(id: string): void {
    if (id === 'opportunity' && this.main.filtersList) {
      this.main.filtersList.opportunity = !this.main?.filtersList.opportunity;
    } else if (id === 'collab' && this.main.filtersList) {
      this.main.filtersList.collab = !this.main?.filtersList.collab;
    }
    this.applySearch();
  }

  // TOGLIE I FILTRI
  removeFilters(): void {
    this.main.resetSearchFilter();
    this.changeActivitiesStatus('', null);
    //TODO rimuovere in pagina ricerca
    this.resetFilterEvent.emit();
    this.applySearch();
  }

  // FILTERS MOBILE
  handleShowFilters(): void {
    this.showFilters = !this.showFilters;
  }

  saveSearches(): void {
    this.saveSearchValue = !this.saveSearchValue;
    this.saveSearch.emit(this.saveSearchValue);
  }

  // NAVIGA AI LINK PRECOSTRUITI
  nav(path): void {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = path;
    }
  }

  // RETURN FILTERS NUMBER
  returnFiltersNumber(value): number {
    let numberOfFilters = 0;
    if (value.categoria) {
      numberOfFilters++;
    }
    numberOfFilters = numberOfFilters + value.filters.map((a) => !a.group).length;
    return numberOfFilters;
  }

  // CHECK IF MOBILE
  @HostListener('window:resize', ['$event']) onResize(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 768;
      // window.innerWidth >= 768 ? this.isMobile = false : this.isMobile = true;
    }
  }

  toggleMobileDropdown(): void {
    this.openFixedList = !this.openFixedList;
    if (this.openFixedList && this.isMobile) {
      this.document.querySelector('html').style.overflowY = 'hidden';
    } else {
      this.document.querySelector('html').style.overflowY = 'unset';
    }
  }

  changeMethod(e: number): void {
    this.searchMethod = e;
  }

  // FILTRO ORDINA ATTIVITA
  changeActivitiesStatus(value: string, toPass: boolean): void {
    this.activitiesLabel = value;
    if (toPass) {
      this.main.orderList.activities = value;
      this.applySearch();
    } else {
      this.main.orderList.activities = '';
    }
  }

  disableRemoveFilters(): boolean {
    return this.main?.returnFilter().filter(a => !a.association).length === 0 && this.main.orderList.activities === '';
  }

  closeZoneSelector(): void {
    this.main.searchDropdownCityZones = false;
    this.document.documentElement.style.overflow = 'unset';
  }

  // OPEN MORE FILTERS POPUP
  showMoreFilters(): void {
    this.showMoreFiltersEvt.emit();
  }

  searchByName(b: boolean): void {
    this.main.isAgentSearch = b;
    // TODO aggiunto !this.isMobile per evitare che venga fatta la chiamata prima di cliccare su conferma
    if (!this.isHome && !this.isWhiteLabel && !this.isMobile) {
      this.removeFilters();
    }
    if (b === false && this.main.searchMethodType === 'name') {
      this.placeholder = 'Inserisci il nome del consulente del credito assicurativo';
    } else {
      this.placeholder = 'Inserisci il nome dell\'agente immobiliare o dell\'agenzia';
    }
    //
    this.resetSuggestionResults();
    if (this.openFixedList && this.isMobile) {
      this.document.querySelector('html').style.overflowY = 'unset';
    }
    this.searchCategoria = null;
  }

  searchByPlace(type: string, agencySearch: boolean): void {
    this.searchByName(agencySearch);
    this.main.searchType = type;
    this.main.searchMethodType = 'place';
    this.placeholder = 'Inserisci Indirizzo, Città, Zona o Disegna sulla mappa';

    if (!this.isHome) {
      this.applySearch();
    }
  }

  resetSuggestionResults(): void {
    this.suggestionResult = null;
    this.toggleSearch = false;
    this.resetAndOpenInput();
  }

  // GESTIONE LOGHI AGENZIA
  handleBrokenLogo(name: string): void {
    this.imgLogoErrorArray.push(name);
  }

  checkBrokenLogo(name: string): boolean {
    return this.imgLogoErrorArray.includes(name);

  }

  openAtecoPopup(el?: any, fullName?: string): void {
    this.popupAtecoIsOpen = true;
    if (el != null) {
      this.atecoObj = el.data;
    }
    if (this.main?.searchType === 'agente') {
      this.atecoType = 'agent';
    } else {
      this.atecoType = 'agency';
    }

    this.atecoType = el.type;

    if (fullName !== '' && fullName !== null) {
      this.atecoAgentFullName = fullName;
    }

    if (el?.data?.esponenti) {
      this.esponenteName = (el?.data?.esponenti || [])
        .map((esponente: any) => esponente.name)
        .filter(Boolean)
        .join(', ');
    }
  }

  closeAtecoPopup(): void {
    this.popupAtecoIsOpen = false;
  }
}
